/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */
import { IMeasurementTypeObject, IObjectKeys } from './UnitModel';

export const measurementTypes: IMeasurementTypeObject[] = [
  {
    measurementType: ['electricity', 'electric'],
    units: {
      'volt-ampere reactive hour': [
        {
          name: 'volt-ampere reactive hour',
          symbol: 'VARH',
          minValue: 0,
          maxValue: 999,
          displayUnit: 'VARH'
        },
        {
          name: 'kilovolt-ampere reactive hour',
          symbol: 'kVARH',
          minValue: 1000,
          maxValue: 999999,
          displayUnit: 'kVARH'
        },
        {
          name: 'megavolt-ampere reactive hour',
          symbol: 'MVARH',
          minValue: 1000000,
          maxValue: 999999999,
          displayUnit: 'MVARH'
        },
        {
          name: 'gigavolt-ampere reactive hour',
          symbol: 'GVARH',
          minValue: 1000000000,
          maxValue: 999999999999,
          displayUnit: 'GVARH'
        },
        {
          name: 'terawattvolt-ampere reactive hour',
          symbol: 'TVARH',
          minValue: 1000000000000,
          maxValue: Number.MAX_VALUE,
          displayUnit: 'TVARH'
        }
      ],
      'watt hour': [
        {
          name: 'watt hour',
          symbol: 'Wh',
          minValue: 0,
          maxValue: 999,
          displayUnit: 'Wh'
        },
        {
          name: 'kilowatt hour',
          symbol: 'kWh',
          minValue: 1000,
          maxValue: 999999,
          displayUnit: 'kWh'
        },
        {
          name: 'megawatt hour',
          symbol: 'MWh',
          minValue: 1000000,
          maxValue: 999999999,
          displayUnit: 'MWh'
        },
        {
          name: 'gigawatt hour',
          symbol: 'GWh',
          minValue: 1000000000,
          maxValue: 999999999999,
          displayUnit: 'GWh'
        },
        {
          name: 'terawatt hour',
          symbol: 'TWh',
          minValue: 1000000000000,
          maxValue: Number.MAX_VALUE,
          displayUnit: 'TWh'
        }
      ],
      watt: [
        {
          name: 'watt',
          symbol: 'W',
          minValue: 0,
          maxValue: 999,
          displayUnit: 'W'
        },
        {
          name: 'kilowatt',
          symbol: 'kW',
          minValue: 1000,
          maxValue: 999999,
          displayUnit: 'kW'
        },
        {
          name: 'megawatt',
          symbol: 'MW',
          minValue: 1000000,
          maxValue: 999999999,
          displayUnit: 'MW'
        },
        {
          name: 'gigawatt',
          symbol: 'GW',
          minValue: 1000000000,
          maxValue: 999999999999,
          displayUnit: 'GW'
        },
        {
          name: 'terawatt',
          symbol: 'TW',
          minValue: 1000000000000,
          maxValue: Number.MAX_VALUE,
          displayUnit: 'TW'
        }
      ],
      'volt ampere': [
        {
          name: 'volt ampere',
          symbol: 'VA',
          minValue: 0,
          maxValue: 999,
          displayUnit: 'VA'
        },
        {
          name: 'kilovolt ampere',
          symbol: 'kVA',
          minValue: 1000,
          maxValue: 999999,
          displayUnit: 'kVA'
        },
        {
          name: 'megavolt ampere',
          symbol: 'MVA',
          minValue: 1000000,
          maxValue: 999999999,
          displayUnit: 'MVA'
        },
        {
          name: 'gigavolt ampere',
          symbol: 'GVA',
          minValue: 1000000000,
          maxValue: 999999999999,
          displayUnit: 'GVA'
        },
        {
          name: 'terawattvolt ampere',
          symbol: 'TVA',
          minValue: 1000000000000,
          maxValue: Number.MAX_VALUE,
          displayUnit: 'TVA'
        }
      ],
      joules: [
        {
          name: 'joules',
          symbol: 'J',
          minValue: 0,
          maxValue: 999,
          displayUnit: 'J'
        },
        {
          name: 'joule',
          symbol: 'J',
          minValue: 0,
          maxValue: 999,
          displayUnit: 'J'
        },
        {
          name: 'kilo joules',
          symbol: 'kJ',
          minValue: 1000,
          maxValue: 999999,
          displayUnit: 'kJ'
        },
        {
          name: 'kilojoule',
          symbol: 'kJ',
          minValue: 1000,
          maxValue: 999999,
          displayUnit: 'kJ'
        },
        {
          name: 'mega joules',
          symbol: 'MJ',
          minValue: 1000000,
          maxValue: 999999999,
          displayUnit: 'MJ'
        },
        {
          name: 'megajoule',
          symbol: 'MJ',
          minValue: 1000000,
          maxValue: 999999999,
          displayUnit: 'MJ'
        },
        {
          name: 'giga joules',
          symbol: 'GJ',
          minValue: 1000000000,
          maxValue: 999999999999,
          displayUnit: 'GJ'
        },
        {
          name: 'gigajoule',
          symbol: 'GJ',
          minValue: 1000000000,
          maxValue: 999999999999,
          displayUnit: 'GJ'
        },
        {
          name: 'tera joules',
          symbol: 'TJ',
          minValue: 1000000000000,
          maxValue: Number.MAX_VALUE,
          displayUnit: 'TJ'
        },
        {
          name: 'terajoule',
          symbol: 'TJ',
          minValue: 1000000000000,
          maxValue: Number.MAX_VALUE,
          displayUnit: 'TJ'
        }
      ]
    }
  },
  {
    measurementType: ['carbon'],
    units: {
      'metric ton': [
        {
          name: 'metric ton',
          symbol: 'ton',
          minValue: 0,
          maxValue: 999,
          displayUnit: 'tons'
        },
        {
          name: 'kilo ton',
          symbol: 'kton',
          minValue: 1000,
          maxValue: 999999,
          displayUnit: 'ktons'
        },
        {
          name: 'million ton',
          symbol: 'Mton',
          minValue: 1000000,
          maxValue: 999999999,
          displayUnit: 'Mtons'
        },
        {
          name: 'giga ton',
          symbol: 'Gton',
          minValue: 1000000000,
          maxValue: 999999999999,
          displayUnit: 'Gtons'
        },
        {
          name: 'tera ton',
          symbol: 'Tton',
          minValue: 1000000000000,
          maxValue: Number.MAX_VALUE,
          displayUnit: 'Ttons'
        }
      ]
    }
  },
  {
    measurementType: ['water', 'sewerage', 'sewer', 'Water', 'Sewer'],
    units: {
      gallon: [
        {
          name: 'gallon',
          symbol: 'gal',
          minValue: 0,
          maxValue: 999,
          displayUnit: 'gal'
        },
        {
          name: 'gallons',
          symbol: 'gal',
          minValue: 0,
          maxValue: 999,
          displayUnit: 'gal'
        },
        {
          name: 'thousand gallon',
          symbol: 'kgal',
          minValue: 1000,
          maxValue: 999999,
          displayUnit: 'kgal'
        },
        {
          name: 'thousand gallons',
          symbol: 'kgal',
          minValue: 1000,
          maxValue: 999999,
          displayUnit: 'kgal'
        },
        {
          name: 'thousand Gallons',
          symbol: 'kgal',
          minValue: 1000,
          maxValue: 999999,
          displayUnit: 'kgal'
        },
        {
          name: 'K gal',
          symbol: 'kgal',
          minValue: 1000,
          maxValue: 999999,
          displayUnit: 'kgal'
        },
        {
          name: 'kgal',
          symbol: 'kgal',
          minValue: 1000,
          maxValue: 999999,
          displayUnit: 'kgal'
        },
        {
          name: 'kilo gallon',
          symbol: 'kgal',
          minValue: 1000,
          maxValue: 999999,
          displayUnit: 'kgal'
        },
        {
          name: 'million gallon',
          symbol: 'Mgal',
          minValue: 1000000,
          maxValue: 999999999,
          displayUnit: 'Mgal'
        },
        {
          name: 'million gallons',
          symbol: 'Mgal',
          minValue: 1000000,
          maxValue: 999999999,
          displayUnit: 'Mgal'
        },
        {
          name: 'M gal',
          symbol: 'Mgal',
          minValue: 1000000,
          maxValue: 999999999,
          displayUnit: 'Mgal'
        },
        {
          name: 'Mgal',
          symbol: 'Mgal',
          minValue: 1000000,
          maxValue: 999999999,
          displayUnit: 'Mgal'
        },
        {
          name: 'mgal',
          symbol: 'Mgal',
          minValue: 1000000,
          maxValue: 999999999,
          displayUnit: 'Mgal'
        },
        {
          name: 'giga gallon',
          symbol: 'Ggal',
          minValue: 1000000000,
          maxValue: 999999999999,
          displayUnit: 'Ggal'
        },
        {
          name: 'tera gallon',
          symbol: 'Tgal',
          minValue: 1000000000000,
          maxValue: Number.MAX_VALUE,
          displayUnit: 'Tgal'
        }
      ],
      'imperial gallon': [
        {
          name: 'imperial gallon',
          symbol: 'igal',
          minValue: 0,
          maxValue: 999,
          displayUnit: 'igal'
        },
        {
          name: 'imperial gallons',
          symbol: 'igal',
          minValue: 0,
          maxValue: 999,
          displayUnit: 'igal'
        },
        {
          name: 'kilo imperial gallon',
          symbol: 'K igal',
          minValue: 1000,
          maxValue: 999999,
          displayUnit: 'k igal'
        },
        {
          name: 'K igal',
          symbol: 'K igal',
          minValue: 1000,
          maxValue: 999999,
          displayUnit: 'k igal'
        },
        {
          name: 'Kigal',
          symbol: 'K igal',
          minValue: 1000,
          maxValue: 999999,
          displayUnit: 'k igal'
        },
        {
          name: 'kigal',
          symbol: 'K igal',
          minValue: 1000,
          maxValue: 999999,
          displayUnit: 'k igal'
        },
        {
          name: 'mega imperial gallon',
          symbol: 'M igal',
          minValue: 1000000,
          maxValue: 999999999,
          displayUnit: 'M igal'
        },
        {
          name: 'million imperial gallon',
          symbol: 'M igal',
          minValue: 1000000,
          maxValue: 999999999,
          displayUnit: 'M igal'
        },
        {
          name: 'million imperial gallons',
          symbol: 'M igal',
          minValue: 1000000,
          maxValue: 999999999,
          displayUnit: 'M igal'
        },
        {
          name: 'M igal',
          symbol: 'M igal',
          minValue: 1000000,
          maxValue: 999999999,
          displayUnit: 'M igal'
        },
        {
          name: 'Migal',
          symbol: 'M igal',
          minValue: 1000000,
          maxValue: 999999999,
          displayUnit: 'M igal'
        },
        {
          name: 'migal',
          symbol: 'M igal',
          minValue: 1000000,
          maxValue: 999999999,
          displayUnit: 'M igal'
        },
        {
          name: 'giga cubic meter',
          symbol: 'G igal',
          minValue: 1000000000,
          maxValue: 999999999999,
          displayUnit: 'G igal'
        },
        {
          name: 'tera imperial gallon',
          symbol: 'T igal',
          minValue: 1000000000,
          maxValue: Number.MAX_VALUE,
          displayUnit: 'T igal'
        }
      ],
      scf: [
        {
          name: 'scf',
          symbol: 'ft3',
          minValue: 0,
          maxValue: 999,
          displayUnit: 'ft3'
        },
        {
          name: 'thousand cubic feet',
          symbol: 'Kcf',
          minValue: 1000,
          maxValue: 999999,
          displayUnit: 'Kcf'
        },
        {
          name: 'million cubic feet',
          symbol: 'MMcf',
          minValue: 1000000,
          maxValue: 9999999,
          displayUnit: 'MMcf'
        },
        {
          name: 'billion cubic feet',
          symbol: 'BCF',
          minValue: 10000000,
          maxValue: Number.MAX_VALUE,
          displayUnit: 'BCF'
        }
      ],
      'standard cubic foot': [
        {
          name: 'standard cubic foot',
          symbol: 'ft3',
          minValue: 0,
          maxValue: 999,
          displayUnit: 'ft3'
        },
        {
          name: 'thousand cubic feet',
          symbol: 'Mcf',
          minValue: 1000,
          maxValue: 9999,
          displayUnit: 'Mcf'
        },
        {
          name: 'million cubic feet',
          symbol: 'MMcf',
          minValue: 10000,
          maxValue: 9999999,
          displayUnit: 'MMcf'
        },
        {
          name: 'billion cubic feet',
          symbol: 'BCF',
          minValue: 10000000,
          maxValue: Number.MAX_VALUE,
          displayUnit: 'BCF'
        }
      ],
      'centum cubic feet': [
        {
          name: 'centum cubic feet',
          symbol: 'Ccf',
          minValue: 0,
          maxValue: 9,
          displayUnit: 'Ccf'
        },
        {
          name: 'thousand cubic feet',
          symbol: 'Kcf',
          minValue: 10,
          maxValue: 9999,
          displayUnit: 'Kcf'
        },
        {
          name: 'Kcf',
          symbol: 'Kcf',
          minValue: 10,
          maxValue: 9999,
          displayUnit: 'Kcf'
        },
        {
          name: 'kcf',
          symbol: 'Kcf',
          minValue: 10,
          maxValue: 9999,
          displayUnit: 'Kcf'
        },
        {
          name: 'Mcf',
          symbol: 'Mcf',
          minValue: 10,
          maxValue: 9999,
          displayUnit: 'Mcf'
        },
        {
          name: 'million cubic feet',
          symbol: 'MMcf',
          minValue: 10000,
          maxValue: 9999999,
          displayUnit: 'MMcf'
        },
        {
          name: 'MMcf',
          symbol: 'MMcf',
          minValue: 10000,
          maxValue: 9999999,
          displayUnit: 'Mcf'
        },
        {
          name: 'billion cubic feet',
          symbol: 'BCF',
          minValue: 10000000,
          maxValue: Number.MAX_VALUE,
          displayUnit: 'BCF'
        }
      ],
      litre: [
        {
          name: 'litre',
          symbol: 'L',
          minValue: 0,
          maxValue: 999.99999999999999,
          displayUnit: 'L'
        },
        {
          name: 'liter',
          symbol: 'L',
          minValue: 0,
          maxValue: 999.99999999999999,
          displayUnit: 'L'
        },
        {
          name: 'kilo litre',
          symbol: 'kL',
          minValue: 1000,
          maxValue: 999999.99999999999999,
          displayUnit: 'kL'
        },
        {
          name: 'KL',
          symbol: 'kL',
          minValue: 1000,
          maxValue: 999999.99999999999999,
          displayUnit: 'kL'
        },
        {
          name: 'kL',
          symbol: 'kL',
          minValue: 1000,
          maxValue: 999999.99999999999999,
          displayUnit: 'kL'
        },
        {
          name: 'million litre',
          symbol: 'ML',
          minValue: 1000000,
          maxValue: 999999999.99999999999999,
          displayUnit: 'ML'
        },
        {
          name: 'giga litre',
          symbol: 'GL',
          minValue: 1000000000,
          maxValue: 999999999999.99999999999999,
          displayUnit: 'GL'
        },
        {
          name: 'tera litre',
          symbol: 'TL',
          minValue: 1000000000000,
          maxValue: Number.MAX_VALUE,
          displayUnit: 'TL'
        }
      ],
      'cubic meter': [
        {
          name: 'cubic meter',
          symbol: 'm3',
          minValue: 0,
          maxValue: 999.99999999999999,
          displayUnit: 'm3'
        },
        {
          name: 'm3',
          symbol: 'm3',
          minValue: 0,
          maxValue: 999.99999999999999,
          displayUnit: 'm3'
        },
        {
          name: 'cm',
          symbol: 'm3',
          minValue: 0,
          maxValue: 999.99999999999999,
          displayUnit: 'm3'
        },
        {
          name: 'cubic_meters',
          symbol: 'm3',
          minValue: 0,
          maxValue: 999.99999999999999,
          displayUnit: 'm3'
        },
        {
          name: 'kilo cubic meter',
          symbol: 'K m3',
          minValue: 1000,
          maxValue: 999999.99999999999999,
          displayUnit: 'K m3'
        },
        {
          name: 'million cubic meter',
          symbol: 'Mm3',
          minValue: 1000000,
          maxValue: 999999999.99999999999999,
          displayUnit: 'Mm3'
        },
        {
          name: 'giga cubic meter',
          symbol: 'Gm3',
          minValue: 1000000000,
          maxValue: 999999999999.99999999999999,
          displayUnit: 'Gm3'
        },
        {
          name: 'tera cubic meter',
          symbol: 'Tm3',
          minValue: 1000000000,
          maxValue: Number.MAX_VALUE,
          displayUnit: 'Tm3'
        }
      ],
      liter: [
        {
          name: 'liter',
          symbol: 'L',
          minValue: 0,
          maxValue: 999.99999999999999,
          displayUnit: 'L'
        },
        {
          name: 'kilo liter',
          symbol: 'kL',
          minValue: 1000,
          maxValue: 999999.99999999999999,
          displayUnit: 'kL'
        },
        {
          name: 'million liter',
          symbol: 'ML',
          minValue: 1000000,
          maxValue: 999999999.99999999999999,
          displayUnit: 'ML'
        },
        {
          name: 'giga liter',
          symbol: 'GL',
          minValue: 1000000000,
          maxValue: 999999999999.99999999999999,
          displayUnit: 'GL'
        },
        {
          name: 'tera liter',
          symbol: 'TL',
          minValue: 1000000000000,
          maxValue: Number.MAX_VALUE,
          displayUnit: 'TL'
        }
      ],
      'watt hour': [
        {
          name: 'watt hour',
          symbol: 'Wh',
          minValue: 0,
          maxValue: 999.99999999999999,
          displayUnit: 'Wh'
        },
        {
          name: 'kilowatt hour',
          symbol: 'kWh',
          minValue: 1000,
          maxValue: 999999.99999999999999,
          displayUnit: 'kWh'
        },
        {
          name: 'megawatt hour',
          symbol: 'MWh',
          minValue: 1000000,
          maxValue: 999999999.99999999999999,
          displayUnit: 'MWh'
        },
        {
          name: 'gigawatt hour',
          symbol: 'GWh',
          minValue: 1000000000,
          maxValue: 999999999999.99999999999999,
          displayUnit: 'GWh'
        },
        {
          name: 'terawatt hour',
          symbol: 'TWh',
          minValue: 1000000000000,
          maxValue: Number.MAX_VALUE,
          displayUnit: 'TWh'
        }
      ],
      'cubic foot': [
        {
          name: 'cubic foot',
          symbol: 'ft3',
          minValue: 0,
          maxValue: 999.99999999999999,
          displayUnit: 'ft3'
        },
        {
          name: 'thousand cubic feet',
          symbol: 'Kcf',
          minValue: 1000,
          maxValue: 999999.99999999999999,
          displayUnit: 'Kcf'
        },
        {
          name: 'million cubic feet',
          symbol: 'MMcf',
          minValue: 1000000,
          maxValue: 9999999.99999999999999,
          displayUnit: 'MMcf'
        },
        {
          name: 'billion cubic feet',
          symbol: 'BCF',
          minValue: 10000000,
          maxValue: Number.MAX_VALUE,
          displayUnit: 'BCF'
        }
      ]
    }
  },
  {
    measurementType: ['gas', 'Gas'],
    units: {
      therm: [
        {
          name: 'therm',
          symbol: 'thm',
          minValue: 0,
          maxValue: 9.99999999999999,
          displayUnit: 'thm'
        },
        {
          name: 'decatherms',
          symbol: 'Dth',
          minValue: 10,
          maxValue: 9999.99999999999999,
          displayUnit: 'Dth'
        },
        {
          name: 'kilo decatherms',
          symbol: 'K Dth',
          minValue: 10000,
          maxValue: Number.MAX_VALUE,
          displayUnit: 'K Dth'
        }
      ],
      'million btu': [
        {
          name: 'million btu',
          symbol: 'MMBTU',
          minValue: 0,
          maxValue: 999.99999999999999,
          displayUnit: 'MMBTU'
        },
        {
          name: 'kilo millionbtu',
          symbol: 'K MMBTU',
          minValue: 1000,
          maxValue: Number.MAX_VALUE,
          displayUnit: 'K MMBTU'
        }
      ],
      millionbtu: [
        {
          name: 'millionbtu',
          symbol: 'MMBTU',
          minValue: 0,
          maxValue: 999.99999999999999,
          displayUnit: 'MMBTU'
        },
        {
          name: 'kilo millionbtu',
          symbol: 'K MMBTU',
          minValue: 1000,
          maxValue: Number.MAX_VALUE,
          displayUnit: 'K MMBTU'
        }
      ],
      joules: [
        {
          name: 'joules',
          symbol: 'J',
          minValue: 0,
          maxValue: 999.99999999999999,
          displayUnit: 'J'
        },
        {
          name: 'joule',
          symbol: 'J',
          minValue: 0,
          maxValue: 999.99999999999999,
          displayUnit: 'J'
        },
        {
          name: 'kilo joules',
          symbol: 'kJ',
          minValue: 1000,
          maxValue: 999999.99999999999999,
          displayUnit: 'kJ'
        },
        {
          name: 'kilojoule',
          symbol: 'kJ',
          minValue: 1000,
          maxValue: 999999.99999999999999,
          displayUnit: 'kJ'
        },
        {
          name: 'mega joules',
          symbol: 'MJ',
          minValue: 1000000,
          maxValue: 999999999.99999999999999,
          displayUnit: 'MJ'
        },
        {
          name: 'mega_joules',
          symbol: 'MJ',
          minValue: 1000000,
          maxValue: 999999999.99999999999999,
          displayUnit: 'MJ'
        },
        {
          name: 'megajoule',
          symbol: 'MJ',
          minValue: 1000000,
          maxValue: 999999999.99999999999999,
          displayUnit: 'MJ'
        },
        {
          name: 'giga joules',
          symbol: 'GJ',
          minValue: 1000000000,
          maxValue: 999999999999.99999999999999,
          displayUnit: 'GJ'
        },
        {
          name: 'gigajoule',
          symbol: 'GJ',
          minValue: 1000000000,
          maxValue: 999999999999.99999999999999,
          displayUnit: 'GJ'
        },
        {
          name: 'tera joules',
          symbol: 'TJ',
          minValue: 1000000000000,
          maxValue: Number.MAX_VALUE,
          displayUnit: 'TJ'
        },
        {
          name: 'terajoule',
          symbol: 'TJ',
          minValue: 1000000000000,
          maxValue: Number.MAX_VALUE,
          displayUnit: 'TJ'
        }
      ],
      mega_joules: [
        {
          name: 'joules',
          symbol: 'J',
          minValue: 0,
          maxValue: 999.99999999999999,
          displayUnit: 'J'
        },
        {
          name: 'joule',
          symbol: 'J',
          minValue: 0,
          maxValue: 999.99999999999999,
          displayUnit: 'J'
        },
        {
          name: 'kilo joules',
          symbol: 'kJ',
          minValue: 1000,
          maxValue: 999999.99999999999999,
          displayUnit: 'kJ'
        },
        {
          name: 'kilojoule',
          symbol: 'kJ',
          minValue: 1000,
          maxValue: 999999.99999999999999,
          displayUnit: 'kJ'
        },
        {
          name: 'mega joules',
          symbol: 'MJ',
          minValue: 1000000,
          maxValue: 999999999.99999999999999,
          displayUnit: 'MJ'
        },
        {
          name: 'mega_joules',
          symbol: 'MJ',
          minValue: 1000000,
          maxValue: 999999999.99999999999999,
          displayUnit: 'MJ'
        },
        {
          name: 'megajoule',
          symbol: 'MJ',
          minValue: 1000000,
          maxValue: 999999999.99999999999999,
          displayUnit: 'MJ'
        },
        {
          name: 'giga joules',
          symbol: 'GJ',
          minValue: 1000000000,
          maxValue: 999999999999.99999999999999,
          displayUnit: 'GJ'
        },
        {
          name: 'gigajoule',
          symbol: 'GJ',
          minValue: 1000000000,
          maxValue: 999999999999.99999999999999,
          displayUnit: 'GJ'
        },
        {
          name: 'tera joules',
          symbol: 'TJ',
          minValue: 1000000000000,
          maxValue: Number.MAX_VALUE,
          displayUnit: 'TJ'
        },
        {
          name: 'terajoule',
          symbol: 'TJ',
          minValue: 1000000000000,
          maxValue: Number.MAX_VALUE,
          displayUnit: 'TJ'
        }
      ],
      'centum cubic feet': [
        {
          name: 'centum cubic feet',
          symbol: 'Ccf',
          minValue: 0,
          maxValue: 9.99999999999999,
          displayUnit: 'Ccf'
        },
        {
          name: 'thousand cubic feet',
          symbol: 'Mcf',
          minValue: 10,
          maxValue: 9999.99999999999999,
          displayUnit: 'Mcf'
        },
        {
          name: 'million cubic feet',
          symbol: 'MMcf',
          minValue: 10000,
          maxValue: 9999999.99999999999999,
          displayUnit: 'MMcf'
        },
        {
          name: 'billion cubic feet',
          symbol: 'BCF',
          minValue: 10000000,
          maxValue: Number.MAX_VALUE,
          displayUnit: 'BCF'
        }
      ],
      'standard cubic meter': [
        {
          name: 'standard cubic meter',
          symbol: 'sm3',
          minValue: 0,
          maxValue: 999.99999999999999,
          displayUnit: 'sm3'
        },
        {
          name: 'sm3',
          symbol: 'sm3',
          minValue: 0,
          maxValue: 999.99999999999999,
          displayUnit: 'sm3'
        },
        {
          name: 'kilo standard cubic meter',
          symbol: 'K sm3',
          minValue: 1000,
          maxValue: 999999.99999999999999,
          displayUnit: 'K sm3'
        },
        {
          name: 'million standard cubic meter',
          symbol: 'M sm3',
          minValue: 1000000,
          maxValue: 999999999.99999999999999,
          displayUnit: 'M sm3'
        },
        {
          name: 'giga standard cubic meter',
          symbol: 'G sm3',
          minValue: 1000000000,
          maxValue: 999999999999.99999999999999,
          displayUnit: 'G sm3'
        },
        {
          name: 'tera standard cubic meter',
          symbol: 'T sm3',
          minValue: 1000000000,
          maxValue: Number.MAX_VALUE,
          displayUnit: 'T sm3'
        }
      ],
      'cubic meter': [
        {
          name: 'cubic meter',
          symbol: 'm3',
          minValue: 0,
          maxValue: 999.99999999999999,
          displayUnit: 'm3'
        },
        {
          name: 'kilo cubic meter',
          symbol: 'K m3',
          minValue: 1000,
          maxValue: 999999.99999999999999,
          displayUnit: 'k m3'
        },
        {
          name: 'million cubic meter',
          symbol: 'M m3',
          minValue: 1000000,
          maxValue: 999999999.99999999999999,
          displayUnit: 'M m3'
        },
        {
          name: 'giga cubic meter',
          symbol: 'G m3',
          minValue: 1000000000,
          maxValue: 999999999999.99999999999999,
          displayUnit: 'G m3'
        },
        {
          name: 'tera cubic meter',
          symbol: 'T m3',
          minValue: 1000000000,
          maxValue: Number.MAX_VALUE,
          displayUnit: 'T m3'
        }
      ],
      'imperial gallon': [
        {
          name: 'imperial gallon',
          symbol: 'igal',
          minValue: 0,
          maxValue: 999,
          displayUnit: 'igal'
        },
        {
          name: 'kilo imperial gallon',
          symbol: 'K igal',
          minValue: 1000,
          maxValue: 999999,
          displayUnit: 'k igal'
        },
        {
          name: 'mega imperial gallon',
          symbol: 'M igal',
          minValue: 1000000,
          maxValue: 999999999,
          displayUnit: 'M igal'
        },
        {
          name: 'giga cubic meter',
          symbol: 'G igal',
          minValue: 1000000000,
          maxValue: 999999999999,
          displayUnit: 'G igal'
        },
        {
          name: 'tera imperial gallon',
          symbol: 'T igal',
          minValue: 1000000000,
          maxValue: Number.MAX_VALUE,
          displayUnit: 'T igal'
        }
      ],
      'normal cubic meter': [
        {
          name: 'normal cubic meter',
          symbol: 'Nm3',
          minValue: 0,
          maxValue: 999,
          displayUnit: 'Nm3'
        },
        {
          name: 'kilo normal cubic meter',
          symbol: 'K Nm3',
          minValue: 1000,
          maxValue: 999999,
          displayUnit: 'K Nm3'
        },
        {
          name: 'million normal cubic meter',
          symbol: 'M Nm3',
          minValue: 1000000,
          maxValue: 999999999,
          displayUnit: 'M Nm3'
        },
        {
          name: 'giga normal cubic meter',
          symbol: 'G Nm3',
          minValue: 1000000000,
          maxValue: 999999999999,
          displayUnit: 'G Nm3'
        },
        {
          name: 'tera normal cubic meter',
          symbol: 'T Nm3',
          minValue: 1000000000,
          maxValue: Number.MAX_VALUE,
          displayUnit: 'T Nm3'
        }
      ],
      btu: [
        {
          name: 'btu',
          symbol: 'BTU',
          minValue: 0,
          maxValue: 999,
          displayUnit: 'BTU'
        },
        {
          name: 'kilobtu',
          symbol: 'k BTU',
          minValue: 1000,
          maxValue: 999999,
          displayUnit: 'k BTU'
        },
        {
          name: 'megabtu',
          symbol: 'M BTU',
          minValue: 1000000,
          maxValue: 999999999,
          displayUnit: 'M BTU'
        },
        {
          name: 'gigabtu',
          symbol: 'G BTU',
          minValue: 1000000000,
          maxValue: Number.MAX_VALUE,
          displayUnit: 'G BTU'
        }
      ],
      'watt hour': [
        {
          name: 'watt hour',
          symbol: 'Wh',
          minValue: 0,
          maxValue: 999,
          displayUnit: 'Wh'
        },
        {
          name: 'kilowatt hour',
          symbol: 'kWh',
          minValue: 1000,
          maxValue: 999999,
          displayUnit: 'kWh'
        },
        {
          name: 'megawatt hour',
          symbol: 'MWh',
          minValue: 1000000,
          maxValue: 999999999,
          displayUnit: 'MWh'
        },
        {
          name: 'gigawatt hour',
          symbol: 'GWh',
          minValue: 1000000000,
          maxValue: 999999999999,
          displayUnit: 'GWh'
        },
        {
          name: 'terawatt hour',
          symbol: 'TWh',
          minValue: 1000000000,
          maxValue: Number.MAX_VALUE,
          displayUnit: 'TWh'
        }
      ],
      scf: [
        {
          name: 'scf',
          symbol: 'ft3',
          minValue: 0,
          maxValue: 999,
          displayUnit: 'ft3'
        },
        {
          name: 'thousand cubic feet',
          symbol: 'Kcf',
          minValue: 1000,
          maxValue: 999999,
          displayUnit: 'Kcf'
        },
        {
          name: 'million cubic feet',
          symbol: 'MMcf',
          minValue: 1000000,
          maxValue: 9999999,
          displayUnit: 'MMcf'
        },
        {
          name: 'billion cubic feet',
          symbol: 'BCF',
          minValue: 10000000,
          maxValue: Number.MAX_VALUE,
          displayUnit: 'BCF'
        }
      ],
      'standard cubic foot': [
        {
          name: 'standard cubic foot',
          symbol: 'ft3',
          minValue: 0,
          maxValue: 999,
          displayUnit: 'ft3'
        },
        {
          name: 'thousand cubic feet',
          symbol: 'Mcf',
          minValue: 1000,
          maxValue: 9999,
          displayUnit: 'Mcf'
        },
        {
          name: 'million cubic feet',
          symbol: 'MMcf',
          minValue: 10000,
          maxValue: 9999999,
          displayUnit: 'MMcf'
        },
        {
          name: 'billion cubic feet',
          symbol: 'BCF',
          minValue: 10000000,
          maxValue: Number.MAX_VALUE,
          displayUnit: 'BCF'
        }
      ],
      'cubic foot': [
        {
          name: 'cubic foot',
          symbol: 'ft3',
          minValue: 0,
          maxValue: 999,
          displayUnit: 'ft3'
        },
        {
          name: 'thousand cubic feet',
          symbol: 'Kcf',
          minValue: 1000,
          maxValue: 999999,
          displayUnit: 'Kcf'
        },
        {
          name: 'million cubic feet',
          symbol: 'MMcf',
          minValue: 1000000,
          maxValue: 9999999,
          displayUnit: 'MMcf'
        },
        {
          name: 'billion cubic feet',
          symbol: 'BCF',
          minValue: 10000000,
          maxValue: Number.MAX_VALUE,
          displayUnit: 'BCF'
        }
      ],
      mmbtu: [
        {
          name: 'mmbtu',
          symbol: 'MMBTU',
          minValue: 0,
          maxValue: 999,
          displayUnit: 'MMBTU'
        },
        {
          name: 'kilo millionbtu',
          symbol: 'K MMBTU',
          minValue: 1000,
          maxValue: Number.MAX_VALUE,
          displayUnit: 'K MMBTU'
        }
      ]
    }
  },
  {
    measurementType: ['steam', 'Steam'],
    units: {
      gram: [
        {
          name: 'gram',
          symbol: 'g',
          minValue: 0,
          maxValue: 999,
          displayUnit: 'g'
        },
        {
          name: 'kilogram',
          symbol: 'kg',
          minValue: 1000,
          maxValue: 999999,
          displayUnit: 'kg'
        },
        {
          name: 'ton',
          symbol: 'K kg',
          minValue: 1000000,
          maxValue: 999999999,
          displayUnit: 'K kg'
        },
        {
          name: 'megaton',
          symbol: 'M kg',
          minValue: 1000000000,
          maxValue: 999999999999,
          displayUnit: 'M kg'
        },
        {
          name: 'gigaton',
          symbol: 'G kg',
          minValue: 1000000000000,
          maxValue: Number.MAX_VALUE,
          displayUnit: 'G kg'
        }
      ],

      'watt hour': [
        {
          name: 'watt hour',
          symbol: 'Wh',
          minValue: 0,
          maxValue: 999,
          displayUnit: 'Wh'
        },
        {
          name: 'kilowatt hour',
          symbol: 'kWh',
          minValue: 1000,
          maxValue: 999999,
          displayUnit: 'kWh'
        },
        {
          name: 'megawatt hour',
          symbol: 'MWh',
          minValue: 1000000,
          maxValue: 999999999,
          displayUnit: 'MWh'
        },
        {
          name: 'gigawatt hour',
          symbol: 'GWh',
          minValue: 1000000000,
          maxValue: 999999999999,
          displayUnit: 'GWh'
        },
        {
          name: 'terawatt hour',
          symbol: 'TWh',
          minValue: 1000000000000,
          maxValue: Number.MAX_VALUE,
          displayUnit: 'TWh'
        }
      ]
    }
  },
  {
    measurementType: ['concentration', 'Concentration'],
    units: {
      'parts per million': [
        {
          name: 'parts per million',
          symbol: 'ppm',
          minValue: 0,
          maxValue: Number.MAX_VALUE,
          displayUnit: 'ppm'
        }
      ]
    }
  }
];

export const responseUnitMapping: IObjectKeys = {
  'watt hour': 'watt hour',
  'kilowatt hour': 'watt hour',
  'megawatt hour': 'watt hour',
  'gigawatt hour': 'watt hour',
  'terawatt hour': 'watt hour',

  'cubic foot': 'cubic foot',

  watt: 'watt',
  kilowatt: 'watt',
  megawatt: 'watt',
  gigawatt: 'watt',
  terawatt: 'watt',
  'kilovolt ampere': 'volt ampere',
  'volt ampere': 'volt ampere',
  kVARH: 'volt-ampere reactive hour',
  'kilovolt-ampere reactive hour': 'volt-ampere reactive hour',

  'metric ton': 'metric ton',
  'kilo ton': 'metric ton',
  'million ton': 'metric ton',

  gallon: 'gallon',
  'kilo gallon': 'gallon',
  'million gallon': 'gallon',
  'giga gallon': 'gallon',
  'tera gallon': 'gallon',
  'imperial gallon': 'imperial gallon',
  'thousand Gallons': 'gallon',
  'thousand gallons': 'gallon',
  gallons: 'gallon',
  'K gal': 'gallon',
  'K igal': 'imperial gallon',
  'million Gallons': 'gallon',
  'million gallons': 'gallon',
  'M gal': 'gallon',
  'M igal': 'imperial gallon',
  migal: 'imperial gallon',
  Migal: 'imperial gallon',
  mgal: 'gallon',
  Mgal: 'gallon',
  kgal: 'gallon',
  'million imperial gallon': 'imperial gallon',
  'kilo imperial gallon': 'imperial gallon',

  litre: 'litre',
  liter: 'litre',

  'kilo litre': 'litre',
  'kilo liter': 'liter',
  'million litre': 'litre',
  'giga litre': 'litre',
  'tera litre': 'litre',
  KL: 'litre',
  kL: 'litre',

  'centum cubic feet': 'centum cubic feet',
  'thousand cubic feet': 'centum cubic feet',
  'million cubic feet': 'centum cubic feet',
  'billion cubic feet': 'centum cubic feet',
  Mcf: 'centum cubic feet',
  kcf: 'centum cubic feet',
  Kcf: 'centum cubic feet',

  therm: 'therm',
  decatherms: 'therm',
  'kilo decatherms': 'therm',

  millionbtu: 'millionbtu',
  mmbtu: 'mmbtu',
  'kilo millionbtu': 'millionbtu',

  joules: 'joules',
  joule: 'joules',
  mega_joules: 'joules',
  'kilo joules': 'joules',
  'mega joules': 'joules',
  'giga joules': 'joules',
  'tera joules': 'joules',
  kilojoule: 'joules',
  megajoule: 'joules',
  gigajoule: 'joules',
  terajoule: 'joules',

  'cubic meter': 'cubic meter',
  'kilo cubic meter': 'cubic meter',
  'million cubic meter': 'cubic meter',
  'giga cubic meter': 'cubic meter',
  'tera cubic meter': 'cubic meter',

  cubic_meters: 'cubic meter',
  'kilo cubic_meters': 'cubic meter',
  'million cubic_meters': 'cubic meter',
  'giga cubic_meters': 'cubic meter',
  'tera cubic_meters': 'cubic meter',
  'cubic meters': 'cubic meter',
  cm: 'cubic meter',
  m3: 'cubic meter',
  sm3: 'standard cubic meter',

  'standard cubic meter': 'standard cubic meter',
  'kilo standard cubic meter': 'standard cubic meter',
  'million standard cubic meter': 'standard cubic meter',
  'giga standard cubic meter': 'standard cubic meter',
  'tera standard cubic meter': 'standard cubic meter',

  'normal cubic meter': 'normal cubic meter',
  'kilo normal cubic meter': 'normal cubic meter',
  'million normal cubic meter': 'normal cubic meter',
  'giga normal cubic meter': 'normal cubic meter',
  'tera normal cubic meter': 'normal cubic meter',

  btu: 'btu',
  'thousand btu': 'btu',
  'million btu': 'million btu',
  'kilo million btu': 'btu',
  megabtu: 'btu',
  kilogram: 'gram',
  scf: 'scf',

  'parts per million': 'parts per million'
};
